import React from "react";
import "./Podium.css"; // Estilização externa para facilitar

const Podium = ({ garcons }) => {
  if (!garcons || garcons.length < 1) return <p className="text-center">Sem dados para exibir.</p>;

  // Ordena os garçons pelo maior aproveitamento
  const top5Garcons = [...garcons]
    .sort((a, b) => {
      const aproveitamentoA = (a.totalLikes / (a.totalLikes + a.totalDislikes)) || 0;
      const aproveitamentoB = (b.totalLikes / (b.totalLikes + b.totalDislikes)) || 0;
      return aproveitamentoB - aproveitamentoA;
    })
    .slice(0, 5); // Pegamos apenas os 5 primeiros

  // Define a posição do pódio baseado no ranking
  const podiumOrder = [1, 0, 2, 3, 4]; // Índice do array ordenado, colocando o 1º no meio
  const heights = [140, 180, 120, 100, 80]; // Alturas para o pódio
  const colors = ["silver", "gold", "#cd7f32", "#A9A9A9", "#A9A9A9"]; // Prata, Ouro, Bronze, Cinza
  const medals = ["🥈", "🥇", "🥉", "🎖", "🎖"]; // Medalhas corretas

  return (
    <div className="podium-container">
      <h3 className="text-center mt-4">
        🏆 <strong>Top 5 Melhor Aproveitamento</strong>
      </h3>
      <div className="podium">
        {podiumOrder.map((pos, index) => {
          if (!top5Garcons[pos]) return null;
          const garcom = top5Garcons[pos];

          return (
            <div
              key={garcom.nome}
              className="podium-bar"
              style={{
                height: `${heights[index]}px`,
                backgroundColor: colors[index],
              }}
            >
              <span className="medal">{medals[index]}</span>
              <span className="garcom-name">{garcom.nome}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Podium;
